import {svgIconWrapper} from '../svg-icon-wrapper';

import PencilRegular from './pencil-regular-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <PencilRegular {...validProps} />;
}

SvgComponent.iconName = 'pencil-regular';

export const PencilRegularIcon = svgIconWrapper(SvgComponent);
